import '../layout/theme';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { PerksLanding } from './components/perks/views/perksLanding/PerksLanding';
import docReady from '../receipts/docReady';
import { sassOptOut } from '../utils/sassOptOut';
import { BaseContentProvider } from './components/stack/components/BaseContentProvider/BaseContentProvider';
import { DefaultLayout } from './components/layout/DefaultLayout';

docReady(() => {
  sassOptOut('forms');
  const container = document.getElementById('PerksContainer');
  if (container) {
    const root = createRoot(container);

    root.render(
      <BaseContentProvider>
        <DefaultLayout>
          <PerksLanding />
        </DefaultLayout>
      </BaseContentProvider>
    );
  }
});
